exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1420px){.table-container[data-v-c5fb90a0]{height:calc(100% - 100px)}}@media (max-width:1420px){.table-container[data-v-c5fb90a0]{height:calc(100% - 135px)}}@media (max-width:1080px){.table-container[data-v-c5fb90a0]{height:calc(100% - 180px)}}@media (max-width:670px){.table-container[data-v-c5fb90a0]{height:calc(100% - 225px)}}[data-v-c5fb90a0] .el-card__body{height:100%}", ""]);

// exports
